<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">交易系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易对提示配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <!-- 搜索框 -->
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="parames.keywords"
            style="width: 300px"
            prefix-icon="el-icon-search"
            placeholder="请输入币种、交易对、提示标题"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="openAddDialog(false)"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
      <!-- table -->
      <el-table :data="dataList" style="width: 100%">
        <el-table-column show-overflow-tooltip prop="tipTitle" label="提示标题">
          <template slot-scope="scope">{{
            scope.row.tipTitle || "--"
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="tipContent"
          label="提示内容"
        >
          <template slot-scope="scope">{{
            scope.row.tipContent || "--"
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="tipJumpMsg"
          label="跳转显示信息"
        >
          <template slot-scope="scope">{{
            scope.row.tipJumpMsg || "--"
          }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="jumpUrl" label="跳转链接">
          <template slot-scope="scope">{{
            scope.row.jumpUrl || "--"
          }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="显示/隐藏">
          <template slot-scope="scope">
            {{ scope.row.showTip ? "显示" : "隐藏" }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="pair"
          label="支持现货交易对"
        >
          <template slot-scope="scope">{{ scope.row.pair || "--" }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="deleteData(scope.row)"
              type="text"
              style="color: red"
              >删除</el-button
            >
            <el-button @click="openAddDialog(scope.row)" type="text"
              >编辑</el-button
            >
            <el-button @click="openTransactionPair(scope.row)" type="text"
              >交易对</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
        v-show="total > 0"
        :size="parames.size"
        :total="total"
        :page="parames.page"
        @pageChanged="pageChanged"
      />
      <!-- 新增编辑弹窗 -->
      <AddDialog ref="AddDialog" @getList="getList" />
      <!-- 交易对 -->
      <TransactionPair ref="TransactionPair" @getList="getList" />
    </el-card>
  </div>
</template>

<script>
import api from "./api";
import Pagination from "components/pagination";
import AddDialog from "./component/AddDialog";
import TransactionPair from "./component/TransactionPair";
export default {
  name: "UserTips",
  components: {
    AddDialog,
    Pagination,
    TransactionPair,
  },
  data() {
    return {
      parames: {
        keywords: "",
        page: 1,
        size: 10,
      },
      total: 0,
      dataList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取数据
    getList() {
      api.getList(this.parames).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 分页数据回调
    pageChanged(e) {
      this.parames = {
        ...this.parames,
        ...e,
      };
      this.getList();
    },
    // 开启新增社保按钮
    openAddDialog(e) {
      if (this.$refs.AddDialog) {
        this.$refs.AddDialog.initData(e);
      }
    },
    // 打开交易对
    openTransactionPair(e) {
      if (this.$refs.TransactionPair) {
        this.$refs.TransactionPair.initData(e);
      }
    },
    // 删除数据
    deleteData(e) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.deleteData({ id: e.id }).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input--prefix .el-input__inner {
  padding-left: 30px !important;
}
</style>
